import Vue from 'vue';
import Vuex from 'vuex';

// import modules from './modules';

Vue.use(Vuex);

export default new Vuex.Store({
    // modules
    state: {
        certificate: {},

        progressBar: 0,
        dashboard: {},

        tableNfeRecebidas: {},
        tableNfeEmitidas: {},
        tableNfeTransportados: {},

        tableCteTodos: {},
        tableCteTomados: {},

        tableNfseRecebidas: {},
        tableNfseEmitidas: {},

        tableClientes: {},
        tableFornecedores: {},

        tableProdutos: {},
        tableProdutosEmitidas: {},

        tableEmpresas: {},
        tableCertificados: {},

        buscaCTE: false,

        files: [],
        expanded: true,
        lastExpandedFolder: { name: '', id: '', parentId: '', origin: '', children: [], },
        breadcrumbs: [ { text: '', id: '', parentId: '' } ],

        mongoFolderReturn: [],
        copyNode: {},
        empresasMenu: {},
        openStore: true,
        updateTable: false,
        ufArray: [],

        dialogWidthRC: 1000,
    },
    getters: {
        certificate(state) {
            return state.certificate;
        },
        progressBar(state) {
            return state.progressBar;
        },
        ufArray(state) {
            return state.ufArray;
        },
        updateTable(state) {
            return state.updateTable;
        },
        dashboard(state) {
            return state.dashboard;
        },
        tableNfseRecebidas(state) {
            return state.tableNfseRecebidas;
        },
        tableNfseEmitidas(state) {
            return state.tableNfseEmitidas;
        },
        tableNfeRecebidas(state) {
            return state.tableNfeRecebidas;
        },
        
        tableNfeEmitidas(state) {
            return state.tableNfeEmitidas;
        },
        tableNfeTransportados(state) {
            return state.tableNfeTransportados;
        },
        tableCteTodos(state) {
            return state.tableCteTodos;
        },
        tableCteTomados(state) {
            return state.tableCteTomados;
        },
        tableClientes(state) {
            return state.tableClientes;
        },
        tableFornecedores(state) {
            return state.tableFornecedores;
        },
        tableProdutos(state) {
            return state.tableProdutos;
        },
        tableProdutosEmitidas(state) {
            return state.tableProdutosEmitidas;
        },
        tableEmpresas(state) {
            return state.tableEmpresas;
        },
        tableCertificados(state) {
            return state.tableCertificados;
        },
        empresasMenu(state) {
            return state.empresasMenu;
        },
        files(state) {
            return state.files;
        },
        openStore(state) {
            return state.openStore;
        },
        dialogWidthRC(state) {
            return state.dialogWidthRC;
        }
    },
    mutations: {
        addCertificate(state, payload) {
            state.certificate = payload;
        },
        addProgressBar(state, payload) {
            state.progressBar = payload;
        },
        addUfArray(state, payload) {
            state.ufArray = payload;
        },
        addUpdateTable(state, payload) {
            state.updateTable = payload;
        },
        addOpenStore(state, payload) {
            state.openStore = payload;
        },
        addEmpresasMenu(state, payload) {
            state.empresasMenu = payload;
        },
        addCopyNode(state, payload) {
            state.copyNode = payload;
        },

        addDashboard(state, payload) {
            state.dashboard = payload;
        },

        addTableNfeRecebidas(state, payload) {
            state.tableNfeRecebidas = payload;
        },

        addTableNfeEmitidas(state, payload) {
            state.tableNfeEmitidas = payload;
        },
        addTableNfeTransportados(state, payload) {
            state.tableNfeTransportados = payload;
        },
        addTableNfeTransportados(state, payload) {
            state.tableNfeTransportados = payload;
        },
        addTableCteTodos(state, payload) {
            state.tableCteTodos = payload;
        },
        addTableCteTomados(state, payload) {
            state.tableCteTomados = payload;
        },

        addTableNfseRecebidas(state, payload) {
            state.tableNfseRecebidas = payload;
        },
        addTableNfseEmitidas(state, payload) {
            state.tableNfseEmitidas = payload;
        },

        addTableClientes(state, payload) {
            state.tableClientes = payload;
        },
        addTableFornecedores(state, payload) {
            state.tableFornecedores = payload;
        },

        addTableProdutos(state, payload) {
            state.tableProdutos = payload;
        },
        addTableProdutosEmitidas(state, payload) {
            state.tableProdutosEmitidas = payload;
        },

        addTableEmpresas(state, payload) {
            state.tableEmpresas = payload;
        },
        addTableCertificados(state, payload) {
            state.tableCertificados = payload;
        },

        addFiles(state, payload) {
            state.files.push(payload);
        },

        newFile(state, payload) {
            state.files[0].push(payload);
        },

        resetFiles(state) {
            state.files.length = [];
        },

        resetBreadcrumbs(state) {
            state.breadcrumbs.length = 0;
        },

        updateBreadcrumbs(state, position) {
            state.breadcrumbs.length = position + 1;
        },

        addLastExpandedFolder(state, payload) {
            const { name, id, parentId, origin, children } = payload;
            state.lastExpandedFolder.name = name;
            state.lastExpandedFolder.id = id;
            state.lastExpandedFolder.parentId = parentId;
            state.lastExpandedFolder.origin = origin;
            state.lastExpandedFolder.children = children;
        },

        addBreadcrumbs(state, payload) {
            const { text, id, parentId } = payload;
            state.breadcrumbs.push({
                text,
                id,
                parentId,
            })
        },

        removeBreadcrumbsLastPosition(state) {
            state.breadcrumbs.splice(state.breadcrumbs.length -1, 1);
        },

        addExpanded(state, payload) {
            state.expanded = payload;
        },

        resetLastExpandedFolder(state) {
            state.lastExpandedFolder = {};
        },

        ressetAllStates(state) {
            state.dashboard = {};
            state.tableNfeRecebidas = {};
            state.tableNfeEmitidas = {};
            state.tableNfeTransportados = {};
            state.tableCteTodos = {};
            state.tableCteTomados = {};
            state.tableNfseRecebidas = {};
            state.tableNfseEmitidas = {};
            state.tableClientes = {};
            state.tableFornecedores = {};
            state.tableProdutos = {};
            state.tableProdutosEmitidas = {};
            state.tableEmpresas = {};
            state.tableCertificados = {};
        },

        addBuscaCTE(state, payload) {
            state.buscaCTE = payload;
        },

        addMongoFolderReturn(state, payload) {
            state.mongoFolderReturn.push(payload);
        },

        resetMongoFolderReturn(state) {
            state.mongoFolderReturn.length = 0;
        },

        addDialogWidthRC(state, payload) {
            state.dialogWidthRC = payload;
        }
    },
});



// WEBPACK FOOTER //
// ./src/store/index.js